import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'Flooring', href: '/flooring' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-warmgray shadow-sm">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/ae54e299-3d8f-4b74-b625-e71d46fd0431/adfc3f16-7512-45a0-8f44-f4a59616e357_boro-logo.jpg?v=cb643541d58765e39496b98c07e6a725"
            alt="Boro Rug Logo"
            className="h-14 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer ${
                location.pathname === link.href
                  ? 'text-bronze'
                  : 'text-charcoal hover:text-bronze'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:+17185550100"
            className="text-sm font-semibold flex items-center gap-2 cursor-pointer transition-colors text-charcoal hover:text-bronze"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-bronze text-base"></i>
            </div>
            (718) 555-0100
          </a>
          <Link
            to="/#quote"
            className="bg-bronze text-white text-sm font-semibold px-6 py-2.5 rounded-md hover:bg-bronze-dark transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Get Estimate
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-charcoal`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-warmgray px-6 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="text-base font-medium text-charcoal hover:text-bronze transition-colors cursor-pointer py-2 border-b border-warmgray last:border-0"
            >
              {link.label}
            </Link>
          ))}
          <a
            href="tel:+17185550100"
            className="flex items-center gap-2 text-base font-medium text-charcoal cursor-pointer py-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-bronze"></i>
            </div>
            (718) 555-0100
          </a>
          <Link
            to="/#quote"
            className="bg-bronze text-white text-center font-semibold px-6 py-3 rounded-md whitespace-nowrap cursor-pointer"
          >
            Get Estimate
          </Link>
        </div>
      )}
    </header>
  );
}
